<template>
  <div class="pt-[72px]">
    <!-- Header -->
    <section class="py-24 text-center px-6">
      <p class="font-label text-xs tracking-wider uppercase text-brand mb-4">Get In Touch</p>
      <h1 class="font-serif text-4xl md:text-5xl text-dark">Contact Us</h1>
      <p class="mt-4 font-sans text-secondary text-lg max-w-2xl mx-auto">
        We'd love to hear from you.
      </p>
    </section>

    <!-- Content -->
    <section class="max-w-3xl mx-auto px-6 pb-24">
      <div class="grid md:grid-cols-2 gap-8">
        <!-- Email -->
        <div class="bg-surface rounded-xl p-6 border border-stroke text-center">
          <p class="font-label text-xs tracking-wider uppercase text-brand mb-3">Email</p>
          <h2 class="font-serif text-2xl text-dark mb-2">Write to Us</h2>
          <p class="font-sans text-secondary">hello@wetwater.com</p>
        </div>

        <!-- Location -->
        <div class="bg-surface rounded-xl p-6 border border-stroke text-center">
          <p class="font-label text-xs tracking-wider uppercase text-brand mb-3">Location</p>
          <h2 class="font-serif text-2xl text-dark mb-2">Visit Us</h2>
          <p class="font-sans text-secondary">Address coming soon</p>
        </div>
      </div>

      <!-- Note -->
      <div class="mt-12 text-center">
        <p class="font-sans text-muted text-sm">
          A contact form will be available here soon.
        </p>
      </div>
    </section>
  </div>
</template>
